import { strDateTimeFormat } from "../date.utils";
import { GALLERY, FILE } from "../data.types";
import { VIRTUAL } from "../object.types";
import { CREATE, UPDATE } from "../crud.types";

import { isLookUpType, isTheTextValue, isProgram } from "./system.service";

const _setRefsEmptyValue = (items, emptyValue) => {
  let result = [];

  result.push(emptyValue);

  items.forEach(item => result.push(item));
  return result;
};

const _objectAttributesName = (names, currentAtributeLang, defaultLang) => {
  const getName = (names, langId) => {
    let item = names.find(n => n.id === langId);
    if (item) {
      return item.value;
    }
    return "";
  };

  let curName = getName(names, currentAtributeLang);

  return currentAtributeLang === defaultLang
    ? `${curName}`
    : `${curName} (${getName(names, defaultLang)})`;
};

const _objectAttributesValue = (
  attributePresets,
  attributeId,
  attributeType
) => {
  let item = attributePresets.find(p => {
    return p.attributeId === attributeId;
  });

  if (item) {
    return item;
  }

  return {
    [attributeType.type.toLowerCase()]: ""
  };
};

const getCountryRefs = (items, emptyName) => {
  return _setRefsEmptyValue(items, {
    id: 0,
    name: emptyName
  });
};

const getCiyRefs = (items, emptyName, countryId) => {
  return _setRefsEmptyValue(
    countryId === "" || countryId === undefined
      ? items
      : items.filter(item => item.countryId === countryId),
    {
      id: 0,
      countryId: 0,
      name: emptyName
    }
  );
};

const selectNavigation = (navList, id) => {
  let result = [];
  let len = navList.length;

  for (let i = 0; i < len; i++) {
    if (navList[i].selected && navList[i].id !== id) {
      result.push({
        index: i,
        value: false
      });
    } else if (navList[i].id === id && !navList[i].selected) {
      result.push({
        index: i,
        value: true
      });
    }
  }

  return result;
};

const objectToFiltersNavigation = (
  objects,
  filter,
  types,
  path,
  id,
  mainObjectId
) => {
  const presetFilter = oldFilter => {
    const setFilterParams = (obj, filterField, newField) => {
      let result = obj;

      if (oldFilter[filterField] !== undefined) {
        result.newFilter[newField] = oldFilter[filterField];
        result.equalFileds.push(newField);
      }

      return result;
    };

    return setFilterParams(
      setFilterParams(
        setFilterParams(
          setFilterParams(
            {
              newFilter: {},
              equalFileds: []
            },
            "countryId",
            "countryId"
          ),
          "cityId",
          "cityId"
        ),
        "type",
        "typesOfObjectsId"
      ),
      "content",
      "attributeExists"
    );
  };

  const changeOldFilter = oldFilter => {
    let result = { ...oldFilter };
    if (
      result.content === undefined ||
      result.content < 0 ||
      result.content > 1
    ) {
      if (result.content !== undefined) {
        delete result.content;
      }
    } else {
      result.content = !!+result.content;
    }
    return result;
  };

  const isFilter = (newFilter, equalFileds, obj) => {
    for (let i = 0; i < equalFileds.length; i++) {
      if (newFilter[equalFileds[i]] !== obj[equalFileds[i]]) {
        return false;
      }
    }

    return true;
  };

  const isNotObjectMain = (mainObjectId, obj) => {
    return mainObjectId ? mainObjectId !== obj.id : true;
  };

  let typeList = types.map(t => t.id);
  let { newFilter, equalFileds } = presetFilter(changeOldFilter(filter));
  let result = [];

  for (let i = 0; i < objects.length; i++) {
    if (
      typeList.indexOf(objects[i].typesOfObjectsId) > -1 &&
      isNotObjectMain(mainObjectId, objects[i])
    ) {
      if (isFilter(newFilter, equalFileds, objects[i])) {
        result.push({
          id: objects[i].id,
          name: objects[i].name,
          url: mainObjectId
            ? `${path}?object=${mainObjectId}&copy_object=${objects[i].id}`
            : `${path}?object=${objects[i].id}`,
          selected: objects[i].id === id
        });
      }
    }
  }

  return result;
};

const objectToNavigation = (obj, path, id) => {
  return {
    id: obj.id,
    name: obj.name,
    url: `${path}?object=${obj.id}`,
    selected: obj.id === id
  };
};

const isObjectByFilter = (obj, filter, types) => {
  if (!types.map(t => t.id).includes(obj.typesOfObjectsId)) {
    return false;
  }

  if (filter.name) {
    if (!obj.name.toUpperCase().includes(filter.name.toUpperCase())) {
      return false;
    }
  }

  if (filter.countryId !== undefined) {
    if (obj.countryId !== filter.countryId) {
      return false;
    }
  }

  if (filter.cityId !== undefined) {
    if (obj.cityId !== filter.cityId) {
      return false;
    }
  }

  if (filter.type !== undefined) {
    if (obj.typesOfObjectsId !== filter.type) {
      return false;
    }
  }

  return true;
};

const getObjectCard = (obj, objTypes) => {
  if (obj) {
    return {
      id: obj.id,
      name: obj.name,
      done: obj.done || false,
      countryId: obj.countryId,
      cityId: obj.cityId,
      type:
        objTypes
          .filter(t => t.id === obj.typesOfObjectsId)
          .map(t => t.name)[0] || "",
      langs: obj.languagesUsed || [],
      lastChanges: {
        user: obj.lastChanges.user,
        date: strDateTimeFormat(obj.lastChanges.date)
      }
    };
  }
  return {};
};

const getRemoveObjectName = (obj, objTypes) => {
  let name = obj.name;
  let type =
    objTypes.filter(t => t.id === obj.typesOfObjectsId).map(t => t.name)[0] ||
    "";

  return `${name} (${type})`;
};

const canBeDeleted = (virtualObjectTypes, obj) => {
  if (obj) {
    return (
      virtualObjectTypes.filter(t => t.id === obj.typesOfObjectsId).length === 1
    );
  }
  return false;
};

const getRemoveObjectFiles = obj => {
  let result = [];
  if (obj.data && obj.data.length) {
    // Атрибуты с файлами, дублируются на всех языках, по этому мы можем брать любой элемент массива
    if (obj.data[0].attributePreset && obj.data[0].attributePreset.length) {
      let gallery = GALLERY.toLowerCase();
      let file = FILE.toLowerCase();
      obj.data[0].attributePreset.forEach(item => {
        if (item[gallery]) {
          item[gallery].forEach(g => {
            result.push(g.url);
          });
        } else if (item[file]) {
          item[file].forEach(f => {
            result.push(f.url);
          });
        }
      });
    }
  }
  return result;
};

const getObjectId = obj => obj.id;

const prepareToSave = obj => {
  let result = {};

  if (obj.name) {
    result.name = obj.name;
  }

  if (obj.objType) {
    result.typesOfObjectsId = obj.objType;
  }

  if (obj.countryId) {
    result.countryId = obj.countryId;
  }

  if (obj.cityId) {
    result.cityId = obj.cityId;
  }

  return result;
};

const prepareToUpdate = obj => {
  let result = {
    name: obj.name,
    languagesUsed: obj.langs || [],
    done: obj.done || false
  };

  if (obj.countryId > 0) {
    result.countryId = obj.countryId;
  }

  if (obj.cityId > 0) {
    result.cityId = obj.cityId;
  }

  return result;
};

const objectAttributes = (
  objectTemplates,
  objectData,
  currentAtributeLang,
  defaultLang,
  done
) => {
  const filterAttr = (templateItem, attrPreset, done) => {
    if (done) {
      return (
        attrPreset.find(
          p => p.attributeId === templateItem.attributeTemplate.id
        ) !== undefined
      );
    }
    return true;
  };

  let attrValue = objectData.find(d => d.languageId === currentAtributeLang);
  let attrPreset = [];

  if (attrValue) {
    attrPreset = attrValue.attributePreset;
  }

  return objectTemplates
    .filter(t => filterAttr(t, attrPreset, done))
    .map(t => {
      return {
        attributeId: t.attributeTemplate.id,
        required: t.required,
        name: _objectAttributesName(
          t.attributeTemplate.names,
          currentAtributeLang,
          defaultLang
        ),
        attributeType: t.attributeTemplate.attributeType,
        value: _objectAttributesValue(
          attrPreset,
          t.attributeTemplate.id,
          t.attributeTemplate.attributeType
        ),
        deleteConfirm: false
      };
    });
};

const objectAttributesName = (objectAttributes, actionAttr) => {
  let item = objectAttributes.find(
    item => item.attributeId === actionAttr.props.attributeId
  );

  if (item) {
    return item.name;
  }
  return "";
};

const objectTypeUsed = arr => arr.filter(a => a.used.length);

const isVirtual = (obj, objTypes) => {
  let item = objTypes.find(t => t.id === obj.typesOfObjectsId);
  if (item) {
    return item.type === VIRTUAL;
  }
  return false;
};

const getLanguages = (obj, languages, objectTemplates) => {
  const isDisabled = (obj, langId, requiredItems) => {
    let items = [];
    if (obj.data && obj.data.length > 0) {
      let itemsLang = obj.data.find(d => d.languageId === langId);

      if (itemsLang && itemsLang.attributePreset) {
        items = itemsLang.attributePreset.filter(p => {
          let used = requiredItems.find(r => {
            if (r.id === p.attributeId) {
              let type = r.type.toLowerCase();

              if (p[type] !== undefined) {
                if (isTheTextValue(r.type) || isProgram(r.type)) {
                  return p[type].length > 0;
                } else {
                  return true;
                }
              }
            }
            return false;
          });

          if (used) {
            return p[used.type.toLowerCase()] !== undefined;
          }

          return false;
        });
      }
    }
    return items.length !== requiredItems.length;
  };

  let requiredItems = objectTemplates
    .filter(t => t.required)
    .map(t => {
      return {
        id: t.attributeTemplate.id,
        type: t.attributeTemplate.attributeType.type
      };
    });

  if (requiredItems) {
    return languages.map(lang => {
      let disabled = false;
      if (!obj.languagesUsed.some(lng => lng === lang.id)) {
        disabled = isDisabled(obj, lang.id, requiredItems);
      }

      return {
        id: lang.id,
        name: lang.name,
        disabled
      };
    });
  }

  return languages.map(lang => {
    return {
      id: lang.id,
      name: lang.name,
      disabled: false
    };
  });
};

const prepareActionAttr = (obj, actionValue, lang, currLang, value) => {
  let action = actionValue.props.value.id === undefined ? CREATE : UPDATE;
  let type = actionValue.props.type.type;

  let params = {
    lang,
    data: {
      type
    }
  };

  if (action === CREATE) {
    params.data.objectId = obj.id;
    params.data.attributeId = actionValue.props.attributeId;
    params.data.languageId = currLang;
  }

  if (action === UPDATE) {
    params.id = actionValue.props.value.id;
  }

  params.data[type.toLowerCase()] = actionValue.val || value;

  return {
    action,
    params
  };
};

const getActionValueType = actionValue => actionValue.props.type.type;
const getActionValueData = actionValue => actionValue.props.value;
const getActionValueRequared = actionValue => actionValue.props.required;
const getActionValueId = actionValue => actionValue.props.attributeId;
const getActionValuePresetData = actionValue =>
  actionValue.props.value[actionValue.props.type.type.toLowerCase()];

const getReferenceSpecificListId = obj => {
  return obj.objectTemplates
    .filter(ot => isLookUpType(ot.attributeTemplate.attributeType.type))
    .map(ot => ot.attributeTemplate.attributeType.lookUpId);
};

const objectInfo = (lang, obj) => {
  return {
    lang,
    data: {
      objectId: getObjectId(obj),
      system: "WEB_DATA"
    }
  };
};

const getDeletedType = (objectAttributeList, id) => {
  let item = objectAttributeList.find(o => o.value.id === id);
  if (item) {
    return item.attributeType.type;
  }

  return false;
};

const getDeletedValue = (objectAttributeList, id) => {
  let item = objectAttributeList.find(o => o.value.id === id);
  if (item) {
    return item.value;
  }

  return false;
};

export {
  getCountryRefs,
  getCiyRefs,
  isObjectByFilter,
  objectToNavigation,
  getObjectCard,
  canBeDeleted,
  getRemoveObjectFiles,
  getObjectId,
  getRemoveObjectName,
  prepareToSave,
  prepareToUpdate,
  objectAttributes,
  objectAttributesName,
  objectTypeUsed,
  isVirtual,
  getLanguages,
  prepareActionAttr,
  getActionValueType,
  getActionValueData,
  getActionValueRequared,
  getActionValueId,
  getActionValuePresetData,
  objectToFiltersNavigation,
  selectNavigation,
  getReferenceSpecificListId,
  objectInfo,
  getDeletedType,
  getDeletedValue
};
